import React from 'react';

import utils from '../../../services/utils';
import { accountSubTypeLabelObject, sourceIconAccountsObject } from '../../../store/catalogs/banks';
import { ReactComponent as Trash } from '../../../assets/icons/Trash.svg';
import { ReactComponent as ArrowDownLine } from '../../../assets/icons/ArrowDownLine.svg';
import { ReactComponent as CircleExclamation } from '../../../assets/icons/CircleExclamation.svg';
import Button from '../../Buttons/Button/Button';
import FieldBold from '../../Fields/FieldBold/FieldBold';
import Tags from '../../Tags/Tags';
import Tooltip from '../../Tooltip/Tooltip';
import { statusAccountTransaction, typesStatusAccount } from '../../../store/constants/statusDruoAccounts';

import classes from './CardCollaboratorResume.module.scss';

const CardCollaboratorResume = ({
  collaborator,
  deleteHandler,
  idx,
  isOneCollaboratorResult,
  downloadHandler,
  showDetailsCollaboratorUnique,
  view
}) => {
  const {
    receiverName,
    receiverLastName,
    salaryToPay,
    salaryValue,
    bankId,
    bankAccountType,
    meloStatus,
    statusDescription,
    bankAccountNumber,
    metadata
  } = collaborator;

  return (
    <div className={classes.card}>
      <div className={classes.head}>
        <span className='semibold-18'>
          {receiverName} {receiverLastName}
        </span>
        <div className={classes.tag}>
          <Tags text={statusAccountTransaction[meloStatus]?.label} type={statusAccountTransaction[meloStatus]?.color} />
          <Tooltip
            classNameChildren={classes.tooltip}
            content={`${statusAccountTransaction[meloStatus]?.tooltip} ${
              meloStatus === typesStatusAccount.ERROR ? statusDescription || '' : ''
            }`}>
            <CircleExclamation />
          </Tooltip>
        </div>
      </div>

      <span className={classes.position}>{metadata.positionLabel}</span>
      <FieldBold title='MONTO A PAGAR' value={utils.moneyFormat(salaryToPay)} />
      <span className={`medium-12 ${classes.base}`}>Salario base: {utils.moneyFormat(salaryValue)}</span>
      <FieldBold title='CUENTA DESTINO'>
        <div className={classes.account}>
          {sourceIconAccountsObject[bankId]}
          <span>
            {accountSubTypeLabelObject[bankAccountType]} ****{utils.getLast4Digit(bankAccountNumber)}
          </span>
        </div>
      </FieldBold>
      <div className={classes.buttons}>
        {deleteHandler ? (
          <>
            <Button custom='quaternary' onClick={() => showDetailsCollaboratorUnique(collaborator)}>
              Ver detalles
            </Button>
            <Button onClick={() => deleteHandler(idx, receiverName)} Icon={Trash} custom='quaternary' color='gray'>
              Eliminar
            </Button>
          </>
        ) : (
          <Button
            {...(!isOneCollaboratorResult && { Icon: ArrowDownLine })}
            custom='quaternary'
            onClick={
              isOneCollaboratorResult
                ? () => showDetailsCollaboratorUnique(collaborator)
                : () => downloadHandler(metadata.collaboratorId)
            }>
            {isOneCollaboratorResult ? 'Ver detalles' : 'Descargar comprobante'}
          </Button>
        )}
      </div>
    </div>
  );
};

export default CardCollaboratorResume;
